<template>
    <div class="promote-card w-100" v-if="counterOfferData">
        <div id="preloader" v-if="load" class="preloader"></div>
        <div class="promote-card-header">
            <div class="header">Let’s Advance this Show</div>
        </div>
        <div class="event-promosion-card">
            <div class="d-flex flex-column w-100">
                <div class="event-details" v-if="!counterOfferData.event_type">
                    <div class="event-details-text">Promotion</div>
                    <div class="header-legend">
                        Use the links below to share and promote this event!
                    </div>
                </div>
                <div class="d-flex share-container" v-if="!counterOfferData.event_type">
                    <div class="share-social">Share:</div>
                    <div class="share-social-wrapper">
                        <div
                            v-for="icon in shareLinkIcons"
                            :key="icon.name"
                            class="d-flex flex-column align-items-center"
                        >
                            <ShareNetwork
                                :network="icon.network"
                                :url="icon.network === 'email' ? '' : shareInfo.url"
                                :title="shareInfo.title"
                                :description="shareInfo.description"
                            >
                                <a class="nostyle" target="_blank">
                                    <img :src="icon.src" alt="icon.name" />
                                </a>
                            </ShareNetwork>
                            <p class="share-text">{{ icon.name }}</p>
                        </div>
                        <div @click="copyUrl" class="d-flex flex-column align-items-center">
                            <img :src="getIcon + 'copy-url.png'" class="share-icon" />
                            <p class="share-text">Copy</p>
                        </div>
                    </div>
                    <!--                    @TODO we have to create a page on instagram and then set up access to the API, our ShareNetwork library does not provide such an opportunity due to the reasons described above-->
                    <!--                    <div class="d-flex flex-column align-items-center">-->
                    <!--                        <img :src="getIcon + 'Instagram-icon.png'" class="share-icon" />-->
                    <!--                        <p class="share-text">Instagram</p>-->
                    <!--                    </div>-->
                    <!--                    @TODO I made a link, but when you go to it, we get 404, I tried to register on tiktok, maybe the problem is that there are no friends and there is no one to send, until I found a solution-->
                    <!--                    <div class="d-flex flex-column align-items-center">-->
                    <!--                        <img :src="getIcon + 'TikTok-icon.png'" class="share-icon" />-->
                    <!--                        <a-->
                    <!--                            class="share-text"-->
                    <!--                            href="https://www.tiktok.com/create?is_copy_url=1&videoDesc=share-tiktok"-->
                    <!--                            target="_blank"-->
                    <!--                        >-->
                    <!--                            TikTok-->
                    <!--                        </a>-->
                    <!--                    </div>-->
                </div>
                <b-modal
                    no-enforce-focus
                    centered
                    hide-header
                    hide-footer
                    id="modal-public-warning"
                    size="l"
                    tabindex=""
                    content-class="modal-saved-event"
                    no-close-on-backdrop
                >
                    <div class="body-container">
                        <div class="d-flex flex-column">
                            <p class="title-warning-message">Check out my upcoming event</p>
                            <p class="warning-message">
                                Hi, I have just created a new event on Hedlyner. Check it out
                                here:
                                <a v-if="urlToCopy" :href="urlToCopy" target="_blank">{{
                                    urlToCopy
                                }}</a>
                            </p>
                        </div>
                    </div>
                </b-modal>
                <hr
                    v-if="!counterOfferData.event_type"
                    style="background: rgb(139, 139, 139); height: 2px; margin-bottom: 20px"
                />
                <div class="event-details-text">Event Details</div>
                <div class="d-flex" :class="{ 'flex-column-reverse': width < 1000 }">
                    <div class="event-right-content">
                        <div class="event-top-info">
                            <div v-if="artists.event_title" class="description">
                                <span class="field-name">Title</span>
                                <span class="event-name">
                                    {{ artists.event_title ? artists.event_title : '' }}
                                </span>
                            </div>
                            <div class="description" v-if="artists.event_description">
                                <span class="field-name">Event Description</span>
                                <span class="description-text">
                                    {{ artists.event_description }}
                                </span>
                            </div>
                        </div>
                        <div class="fields">
                            <div v-if="artists.event_start_time" class="event-field">
                                <p class="field-name">Doors at</p>
                                <p class="field-value">{{ artists.event_start_time }}</p>
                            </div>
                            <div class="event-field" v-if="artists.cover_cost">
                                <p class="field-name">Cover Price</p>
                                <p class="field-value">${{ parseInt(artists.cover_cost) }}</p>
                            </div>
                            <div class="event-field" v-if="artists.min_age">
                                <p class="field-name">Minimum Age</p>
                                <p class="field-value">{{ artists.min_age }}</p>
                            </div>
                        </div>
                        <section class="venue-info">
                            <div class="venue-place">
                                <span class="field-name">At</span>
                                <span class="field-value">{{
                                    counterOfferData.venue_name
                                        ? counterOfferData.venue_name
                                        : venueInfo.venue_name
                                }}</span>
                            </div>
                            <div class="field-location">
                                <div class="main-info">
                                    <div class="field-info">
                                        <img
                                            :src="
                                                getIcon +
                                                'icons/social/advance-artist/Group.svg'
                                            "
                                            alt="contact"
                                        />
                                        Contact: {{ venueInfo.user_name }}
                                    </div>
                                    <div class="field-info">
                                        <img
                                            :src="
                                                getIcon + 'icons/social/Verticalcontainer.svg'
                                            "
                                        />
                                        {{
                                            counterOfferData.address
                                                ? counterOfferData.address
                                                : venueInfo.venue_address
                                        }}
                                    </div>
                                </div>
                                <div class="contact-info">
                                    <div class="social-venue">
                                        <div v-for="social in socialVenue" :key="social.id">
                                            <a :href="social.link" target="_blank">
                                                <img :src="getSocilaImg(social.link)"
                                            /></a>
                                        </div>
                                        <div
                                            class="artist-website"
                                            v-if="venueInfo.venue_website"
                                        >
                                            <a
                                                :href="venueInfo.venue_website"
                                                target="_blank"
                                                class="web-img"
                                            >
                                                <img
                                                    :src="
                                                        getIcon +
                                                        'icons/social/advance-artist/web.svg'
                                                    "
                                                />{{ venueInfo.venue_website }}
                                            </a>
                                        </div>
                                    </div>
                                    <div class="phone-number" v-if="venueInfo.venue_phone">
                                        <img
                                            :src="
                                                getIcon +
                                                'icons/social/advance-artist/phone.svg'
                                            "
                                            alt=""
                                        />
                                        <span class="website">{{
                                            venueInfo.venue_phone
                                        }}</span>
                                    </div>
                                </div>
                                <button class="message-cta" @click="mailTo">
                                    Send Message
                                </button>
                            </div>
                        </section>
                        <section class="payment-section">
                            <div class="payout-value">
                                <div class="payout-info">
                                    <div class="field-value">
                                        You Get: ${{ getArtistPayout }}
                                    </div>
                                </div>
                                <div class="event-time-duration">
                                    <div v-if="detailsAccepted" class="event-time">
                                        Set Start Time: {{ reviewSetInfo.start }}
                                    </div>
                                    <div v-else class="event-time">
                                        Set Start Time:
                                        {{ venueInfo.set_start_avail }}
                                    </div>
                                    <div v-if="detailsAccepted" class="event-time">
                                        Set Duration:
                                        {{
                                            Math.round(
                                                parseFloat(
                                                    reviewSetInfo.duration * 60
                                                ).toFixed(0)
                                            )
                                        }}min
                                    </div>
                                    <div v-else class="event-time">
                                        Set Duration:
                                        {{
                                            parseFloat(venueInfo.set_duration * 60).toFixed(0)
                                        }}min
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="opportunity-details">
                            <div class="details-text"><span>Opportunity Details</span></div>
                            <div
                                v-if="artists.opportunity_detail"
                                class="details-text"
                                style="font-size: 16px"
                            >
                                <span class="description-text">
                                    {{ artists.opportunity_detail }}
                                </span>
                            </div>
                        </section>
                        <div class="artist-oder" v-if="artists.with.length">
                            <div class="label-info">Artist Order</div>
                            <div class="artist-order-info">
                                <div
                                    class="artist-card"
                                    v-for="(artist, index) in artists.with"
                                    :key="index"
                                    :style="{
                                        'border-bottom':
                                            index < artists.length - 1
                                                ? '1px solid #8b8b8b'
                                                : 'none'
                                    }"
                                >
                                    <div class="artist-info">
                                        <div class="artist-order-number" style="width: 40px">
                                            {{ index + 1 }}.
                                        </div>
                                        <div class="artist-order-photo">
                                            <img
                                                :src="artist.avatar"
                                                alt="artist-image"
                                                class="artist-image"
                                            />
                                        </div>
                                        <div class="set-info">
                                            <div class="artist-name">
                                                {{ artist.band_name }}
                                            </div>
                                            <div class="d-flex flex-column align-items-start">
                                                <div>
                                                    <span class="set-lenght">Set Length</span>
                                                    <span
                                                        v-if="detailsAccepted"
                                                        class="set-data"
                                                    >
                                                        {{
                                                            `${Math.round(
                                                                parseFloat(
                                                                    reviewSetInfo.duration * 60
                                                                ).toFixed(0)
                                                            )}`
                                                        }}min
                                                    </span>
                                                    <span v-else class="set-data">
                                                        {{
                                                            Math.round(
                                                                parseFloat(
                                                                    artist.counter_offer_duration *
                                                                        60
                                                                ).toFixed(0)
                                                            )
                                                        }}min
                                                    </span>
                                                </div>
                                                <div>
                                                    <span class="set-lenght">Start at</span>
                                                    <span
                                                        v-if="detailsAccepted"
                                                        class="set-data"
                                                    >
                                                        {{ reviewSetInfo.start }}
                                                    </span>
                                                    <span v-else class="set-data">
                                                        {{ artist.start_avail }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="event-btns">
                            <button
                                v-if="!counterOfferData.event_type"
                                @click="goToEventPage"
                                class="save-btn"
                            >
                                <span class="save-btn-text">View Event Page</span>
                            </button>
                            <button v-b-modal.modal-cancel-event class="cancel-event-btn">
                                Cancel my perfomance
                            </button>
                        </div>
                        <b-modal
                            no-enforce-focus
                            centered
                            hide-header
                            hide-footer
                            id="modal-cancel-event"
                            content-class="cancel-event-modal"
                            size="xl"
                        >
                            <p class="modal-title-text">You are about to cancel this event</p>
                            <p class="modal-warning-text">
                                Are you sure you want to cancel your performance at this event?
                            </p>
                            <div class="d-flex flex-column align-items-center">
                                <button class="return-btn" @click="cancelEvent">
                                    Yes, cancel this event
                                </button>
                                <p
                                    class="cancel-btn"
                                    @click="$bvModal.hide('modal-cancel-event')"
                                    slot="modal-footer"
                                >
                                    No, return back
                                </p>
                            </div>
                        </b-modal>
                    </div>
                    <div class="event-left-content">
                        <div class="event-photo">
                            <img
                                v-if="!artists.event_picture"
                                :src="getIcon + 'default-artist-event.png'"
                                class="upload-image"
                            />
                            <img
                                v-if="artists.event_picture"
                                :src="artists.event_picture"
                                class="upload-image"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ReviewSetModal
            :show.sync="reviewSet"
            :event-id="parseInt(eventId)"
            :set="reviewSetInfo"
            :mode="reviewSetMode"
            @loading="handleAPILoading"
            @changes-accepted="acceptSetChanges"
        />
    </div>
</template>

<script>
    import axios from 'axios'
    import ReviewSetModal from './review-set/ReviewSetModal.vue'
    import { notification } from '@/helpers/notification'
    import checkScreen from '@/mixins/check-screen'

    const URLS = {
        xhr: {
            fetch: {
                setChanges: '/api/event/manage/set-changes'
            }
        }
    }

    export default {
        props: {
            eventId: {
                type: Number
            },
            eventDate: {
                type: String
            },
            counterOfferData: {
                type: Object
            },
            artistId: {
                type: Number
            }
        },
        name: 'AdvancedStep',
        components: {
            ReviewSetModal
        },
        mixins: [checkScreen],
        data: () => ({
            load: false,
            detailsAccepted: false,
            payoutAccepted: false,
            reviewSet: false,
            reviewSetMode: 'details',
            reviewSetInfo: null,
            startTime: '',
            eventTitle: '',
            endTime: '',
            coverPrice: '',
            minimumAge: '',
            eventDescription: '',
            image: null,
            artists: [],
            eventTitleError: false,
            startTimeError: false,
            shareLinkIcons: [
                {
                    name: 'Email',
                    network: 'email',
                    src: '/images/email-icon.png'
                },
                {
                    name: 'Twitter',
                    network: 'twitter',
                    src: '/images/Twitter-icon.png'
                },
                {
                    name: 'Facebook',
                    network: 'facebook',
                    src: '/images/Facebook-icon.png'
                }
            ],
            venueInfo: {},
            socialVenue: [],
            socialIcons: [
                { instagram: '/images/icons/social/advance-artist/instagram.svg' },
                { yelp: '/images/icons/social/advance-artist/yelp.svg' },
                { facebook: '/images/icons/social/advance-artist/facebook.svg' },
                { google: '/images/icons/social/advance-artist/google.svg' }
            ],
            urlToCopy: '',
            urlToPublishEvent: ''
        }),
        watch: {
            counterOfferData: {
                handler: async function (data) {
                    await this.initVenueAndSetChangesData(data)
                },
                immediate: true
            }
        },
        methods: {
            async initVenueAndSetChangesData(data) {
                try {
                    await this.getVenueInfo()

                    const status = data?.counter_offer_status
                    if (status === 7 || status === 8) {
                        try {
                            this.load = true
                            const response = await axios.get(
                                `${URLS.xhr.fetch.setChanges}/${this.eventId}/${this.artistId}`
                            )
                            data = {
                                ...data,
                                newDuration: response.data.data.duration,
                                payout: response.data.data.amount,
                                artistCommission: response.data.data.commission,
                                artistFees: response.data.data.artistFees,
                                start: response.data.data.start_avail
                            }
                            if (status === 7) {
                                this.reviewSetDetails(data)
                            } else {
                                this.reviewSetPayout(data)
                            }
                        } catch (error) {
                            console.error(error)
                        } finally {
                            this.load = false
                        }
                    }
                } catch (error) {
                    console.error(error)
                }
            },
            acceptSetChanges() {
                switch (this.reviewSetMode) {
                    case 'details':
                        this.detailsAccepted = true
                        break
                    case 'payout':
                        this.payoutAccepted = true
                        break
                    default:
                        return
                }
            },
            handleAPILoading(loading) {
                this.load = loading
            },
            reviewSetPayout(data) {
                const payout = data.individual_payouts.find(
                    (payout) => payout.users_artist_id === this.artistId
                )

                const artistGets = data.payout
                const hedlynerCommission = data.artistCommission
                const artistFee = data.artistFees

                this.reviewSet = true
                this.reviewSetMode = 'payout'
                this.reviewSetInfo = {
                    eventId: parseInt(this.eventId),
                    artistId: parseInt(this.artistId),
                    venueId: parseInt(this.venueInfo.venue_id),
                    avatar: data.picture,
                    venueName: data.venue_name,
                    duration: data.newDuration,
                    prevDuration: this.bidArtist.counter_offer_duration,
                    start: data.start,
                    prevStart: this.bidArtist.start_avail,
                    prevPayout: payout.payout,
                    payout: artistGets,
                    hedlynerCommission: hedlynerCommission,
                    artistFee: artistFee
                }
            },
            reviewSetDetails(data) {
                const payout = data.individual_payouts.find(
                    (payout) => payout.users_artist_id === this.artistId
                )
                const artistGets = data.payout
                const hedlynerCommission = data.artistCommission
                const artistFee = data.artistFees

                this.reviewSet = true
                this.reviewSetMode = 'details'
                this.reviewSetInfo = {
                    eventId: parseInt(this.eventId),
                    artistId: parseInt(this.artistId),
                    venueId: parseInt(this.venueInfo.venue_id),
                    avatar: data.picture,
                    venueName: data.venue_name,
                    duration: data.newDuration,
                    prevDuration: this.bidArtist.counter_offer_duration,
                    start: data.start,
                    prevStart: this.bidArtist.start_avail,
                    prevPayoutpayout: payout.payout,
                    payout: artistGets,
                    hedlynerCommission: hedlynerCommission,
                    artistFee: artistFee
                }
            },
            mailTo() {
                sessionStorage.setItem('recipient_id', this.venueInfo.venue_user_id)
                window.open('/profile/mail-chat', '_blank')
            },
            async cancelEvent() {
                try {
                    const response = await axios.put(
                        '/api/bookings/' + this.artists.booking_id + '/rejected'
                    )
                    await axios.put('/api/event/reject/' + this.eventId)
                    notification('success', response.data.message)
                    window.location.href = '/booking-manager/artist'
                } catch (error) {
                    notification('error', error)
                }
            },
            async getBookedArtist() {
                try {
                    const { data } = await axios.get(
                        '/api/booking-manager/artist/' + this.eventId + '/advance'
                    )
                    this.artists = data.data
                    const domainName = window.location.origin
                    this.urlToPublishEvent = domainName + '/event/show/' + this.eventId
                } catch (error) {
                    notification('error', error)
                }
            },
            async getVenueInfo() {
                try {
                    const { data } = await axios.get(
                        '/api/booking-manager/artist/' +
                            this.eventId +
                            '/advance-venue-info/' +
                            this.artistId
                    )
                    this.venueInfo = data.data
                    this.socialVenue = data.data.venue_social_links
                } catch (e) {
                    console.error(e)
                }
            },
            getUser() {
                const url = window.location.href

                return url.split('/').slice(-1)[0]
            },
            copyUrl() {
                const domainName = window.location.origin
                this.urlToCopy = domainName + '/event/show/' + this.eventId
                const tempInput = document.createElement('input')
                tempInput.value = this.urlToCopy
                document.body.appendChild(tempInput)
                tempInput.select()
                document.execCommand('copy')
                document.body.removeChild(tempInput)
                this.$bvModal.show('modal-public-warning')
                setTimeout(() => {
                    this.$bvModal.hide('modal-public-warning')
                }, 5000)
            },
            goToEventPage() {
                window.location.href = '/event/show/' + this.eventId
            },
            getSocilaImg(social) {
                for (const icon of this.socialIcons) {
                    const network = Object.keys(icon)[0]
                    if (social.includes(network)) {
                        return icon[network]
                    }
                }
                return ''
            }
        },
        computed: {
            bidArtist() {
                return this.counterOfferData.bid_artists_info.find(
                    (a) => a.artist_id === this.artistId
                )
            },
            getArtistPayout() {
                const payout = this.counterOfferData.individual_payouts.find(
                    (payout) => payout.users_artist_id === this.artistId
                )

                return payout ? payout.payout : 'N/A'
            },
            getIcon() {
                return '/images/'
            },
            shareInfo: (self) => ({
                url: self.urlToPublishEvent,
                title: 'Check out my upcoming event',
                description: `Hi, I have just created a new event on Hedlyner. Check it out here: ${self.urlToPublishEvent}`
            })
        },
        async created() {
            await this.getBookedArtist()
        },
        beforeDestroy() {
            localStorage.removeItem('eventDate')
        }
    }
</script>

<style lang="scss">
    /* Needed elsewhere, with same class name for bootstrap modal */
    .cancel-event-modal {
        display: inline-flex;
        padding: 48px 80px;
        justify-content: center;
        border-radius: 20px;
        background: #161616;

        @media screen and (max-width: 768px) {
            padding: 16px;
        }
    }
</style>

<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';
    .details-text {
        color: #acacac;
        font-family: 'Instrument Sans';
        font-size: 12px;
        font-style: normal;
        font-weight: 650;
        line-height: 135%;
        letter-spacing: 0.12px;
    }
    .opportunity-details {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 6px;
        align-self: stretch;
    }
    .web-img {
        display: flex;
        justify-content: center;
        gap: 4px;
        align-items: center;
        color: #acacac;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        text-decoration: none;
    }
    .artist-website {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
    }
    .description-text {
        color: #acacac;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        max-width: 661px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
    }
    .description {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 6px;
        align-self: stretch;
    }
    .event-top-info {
        display: flex;
        width: 491px;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
    }
    .event-time {
        color: #cb9b1f;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%; /* 20px */
    }
    .event-time-duration {
        display: flex;
        align-items: flex-start;
        gap: 8px;
    }
    .venue-pays {
        color: #acacac;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .payout-info {
        display: flex;
        align-items: center;
        gap: 24px;
    }
    .payout-value {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 8px;
        align-self: stretch;
    }
    .payment-section {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        align-self: stretch;
    }
    .field-info {
        display: flex;
        align-items: flex-start;
        gap: 4px;
        align-self: stretch;
        color: #acacac;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .main-info {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        align-self: stretch;
    }
    .venue-place {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 6px;
        align-self: stretch;
    }
    a {
        text-decoration: none;
    }
    .phone-number {
        display: flex;
        align-items: center;
        gap: 4px;
    }
    .website {
        color: #acacac;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        text-decoration: none;
    }
    .field-location {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        align-self: stretch;
    }
    .venue-info {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        align-self: stretch;
    }
    .social-venue {
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .contact-info {
        display: flex;
        align-items: flex-start;
        align-items: center;
        gap: 16px;
    }
    .message-cta {
        display: flex;
        padding: 7px 20px 10px 20px;
        justify-content: center;
        align-items: center;
        border-radius: 100px;
        background: #cb9b1f;
        border: 0;
        color: #000;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .warning-message {
        color: #acacac;
        text-align: center;
        font-family: 'Instrument Sans';
        font-size: 14px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .title-warning-message {
        color: #198754;
        text-align: center;
        font-family: 'Instrument Sans';
        font-size: 38px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
    }
    .body-container {
        display: flex;
        flex-direction: column;
        gap: 48px;
    }
    .cancel-btn {
        color: #8b8b8b;
        text-align: center;
        font-family: 'Studio Pro';
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 120%;
        text-decoration-line: underline;
        cursor: pointer;
    }
    .modal-title-text {
        color: #f5f5f5;
        font-family: 'Instrument Sans';
        font-size: 44px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
        text-align: center;
    }
    .modal-warning-text {
        color: #acacac;
        text-align: center;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 650;
        line-height: 120%;
        text-align: center;
    }
    .return-btn {
        padding: 11px 30px 12px 30px;
        border-radius: 100px;
        background: #cdeb09;
        color: #000;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 650;
        line-height: 120%;
        border: 0;
        max-height: 90px;
        margin-bottom: 24px;
        margin-top: 40px;
    }
    .cancel-event-btn {
        padding: 11px 20px 12px 20px;
        border-radius: 100px;
        border: 1px solid #cb9b1f;
        background: #262626;
        color: #cb9b1f;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 650;
        line-height: 120%;
        flex: 0 1 50%;
    }
    .event-right-content {
        display: flex;
        flex-direction: column;
        gap: 32px;
        flex: 0 1 75%;
        margin-top: 20px;
    }
    .event-left-content {
        flex: 0 1 25%;
    }
    .field-description {
        white-space: pre-line;
        max-width: 661px;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #acacac;
        font-family: Instrument Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 650;
        line-height: 125%;
    }
    .fields {
        display: flex;
        align-items: center;
        gap: 20px;
    }
    .event-field {
        display: flex;
        flex-direction: column;
        gap: 6px;
        flex: 0 1 20%;
    }
    .field-value {
        margin-bottom: 0;
        overflow: hidden;
        color: #cb9b1f;
        text-overflow: ellipsis;
        font-family: Instrument Sans;
        font-size: 32px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.64px;
    }
    .event-name {
        overflow: hidden;
        color: #cb9b1f;
        text-overflow: ellipsis;
        font-family: Instrument Sans;
        font-size: 32px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.64px;
    }
    .field-name {
        color: #acacac;
        font-family: Instrument Sans;
        font-size: 12px;
        font-style: normal;
        font-weight: 650;
        line-height: 135%;
        letter-spacing: 0.12px;
        margin-bottom: 0;
    }
    input[type='time']::-webkit-calendar-picker-indicator {
        background: none;
    }
    .upload-image {
        border-radius: 10px;
        border: 1px solid #8b8b8b;
        filter: brightness(55%);
        cursor: pointer;
        max-width: 320px;
        max-height: 330px;
        object-fit: cover;
    }
    .share-container {
        gap: 30px;
        margin-top: 25px;
    }
    .share-icon {
        max-width: 44px;
        max-height: 44px;
        cursor: pointer;
    }
    .share-text {
        color: #dedede;
        text-align: center;
        font-size: 12px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 650;
        line-height: 135%;
        letter-spacing: 0.12px;
        margin-top: 7px;
        text-decoration: none;
        cursor: pointer;
    }
    .promote-card {
        display: flex;
        flex-direction: column;
        padding: 20px 25px;
        background: #000;
    }
    .promote-card-header {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }
    .header {
        color: #cb9b1f;
        font-size: 44px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
    }
    .header-legend {
        color: #8b8b8b;
        font-size: 16px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .event-promosion-card {
        display: flex;
        flex-direction: row;
        border-radius: 15px;
        background: #262626;
        padding: 20px 25px 32px 25px;
        align-items: flex-start;
        margin-top: 25px;
    }
    .event-details {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        flex-direction: column;
    }
    .event-details-text {
        color: #acacac;
        font-family: 'Instrument Sans';
        font-size: 26px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.52px;
    }
    .event-details-promotion {
        color: #dedede;
        font-size: 26px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.52px;
    }
    .label-info {
        color: #dedede;
        font-size: 12px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 650;
        line-height: 135%;
        letter-spacing: 0.12px;
    }
    .artist-oder {
        margin-top: 20px;
        display: flex;
        flex-direction: column;
    }

    .artist-order-info {
        display: flex;
        padding: 12px 15px 15px 15px;
        flex-direction: column;
        gap: 12px;
        border-radius: 12px;
        border: 1.5px solid #8b8b8b;
        background: #262626;
        cursor: pointer;
    }
    .artist-card {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    .artist-info {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 16px;
    }
    .event-btns {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 25px;
    }
    .save-btn {
        border-radius: 100px;
        background: #cb9b1f;
        display: flex;
        padding: 11px 20px 12px 20px;
        justify-content: center;
        align-items: center;
        flex: 0 1 50%;
        margin-right: 5px;
        border: 0;
    }
    .save-btn-text {
        color: #000000;
        font-size: 18px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
    }
    .event-photo {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 20px;
        position: relative;
    }
    .artist-order-number {
        color: #8b8b8b;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 120%;
        letter-spacing: -0.52px;
    }
    .set-info {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: flex-start;
        gap: 8px;
        flex: 1 0 0;
    }
    .artist-name {
        overflow: hidden;
        color: #dedede;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 650;
        line-height: 120%;
    }
    .artist-order-photo {
        border-radius: 9px;
        background: lightgray 50% / cover no-repeat;
        margin-right: 15px;
    }
    .artist-image {
        height: 64px;
        width: 64px;
        border-radius: 8px;
    }
    .set-data {
        color: #acacac;
        font-family: 'Instrument Sans';
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 130%;
        letter-spacing: 0.14px;
    }
    .set-lenght {
        color: #646464;
        font-size: 14px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 600;
        line-height: 160%;
        letter-spacing: -0.16px;
    }
    .share-social {
        color: #cb9b1f;
        font-size: 44px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
    }
    .share-social-wrapper {
        display: flex;
        gap: 10px;
    }
    @media (max-width: 1000px) {
        .header {
            font-size: 38px;
        }
        .event-photo {
            display: block;
            margin: 0;
        }
        .fields {
            flex-direction: column;
            align-items: flex-start;
        }
        .event-btns {
            align-items: normal;
            gap: 10px;
            flex-direction: column;
        }
        .share-social {
            font-size: 38px;
        }
        .event-promosion-card {
            background: transparent;
            padding: 0;
        }
        .share-container {
            flex-direction: column;
        }
        .promote-card {
            padding: 20px 16px;
        }
        .cancel-event-btn {
            background: transparent;
        }
    }
</style>
